export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["सहेजें"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["यदि आप इसे देखते हैं, तो फॉर्म प्राप्त नहीं हुआ है (लेकिन आपको यह नहीं देखना चाहिए)"])}
}